import { Box, styled } from '@mui/material';

const StyledAppbarLogoContainer = styled(Box)(({ theme }) => ({
  display: 'block',
  width: '113px',
  // El logotipo es blanco; en claro hay que oscurecerlo para que no se pierda.
  '& svg': { filter: theme.palette.mode === 'light' ? 'brightness(0)' : 'none' },
  [theme.breakpoints.up('lg')]: {
    display: 'none'
  }
}));

export default StyledAppbarLogoContainer;
